export const toRadians = (degrees) => {
    return (Math.PI * degrees) / 180;
};
export const toDegrees = (radians) => {
    return (180 * radians) / Math.PI;
};
export const length = (x, y) => {
    return Math.sqrt(x * x + y * y);
};
export const toWindDirection = (radians) => {
    return 270 - (180 * radians) / Math.PI + (360 % 360);
};
export const NearestNeighbourInterpolator = {
    value: (p, t) => (t < 0.5 ? p[0] : p[1]),
    biValue: (p, tx, ty) => NearestNeighbourInterpolator.value([
        NearestNeighbourInterpolator.value(p[0], ty),
        NearestNeighbourInterpolator.value(p[1], ty),
    ], tx),
    triValue: (p, tx, ty, tz) => NearestNeighbourInterpolator.value([
        NearestNeighbourInterpolator.biValue(p[0], ty, tz),
        NearestNeighbourInterpolator.biValue(p[2], ty, tz),
    ], tx),
};
export const LinearInterpolator = {
    value: (p, t) => p[0] * (1 - t) + p[1] * t,
    biValue: (p, tx, ty) => LinearInterpolator.value([LinearInterpolator.value(p[0], ty), LinearInterpolator.value(p[1], ty)], tx),
    triValue: (p, tx, ty, tz) => LinearInterpolator.value([
        LinearInterpolator.biValue(p[0], ty, tz),
        LinearInterpolator.biValue(p[2], ty, tz),
    ], tx),
};
export const CubicInterpolator = {
    //https://www.paulinternet.nl/?page=bicubic
    value: (p, t) => p[1] +
        0.5 *
            t *
            (p[2] -
                p[0] +
                t *
                    (2.0 * p[0] -
                        5.0 * p[1] +
                        4.0 * p[2] -
                        p[3] +
                        t * (3.0 * (p[1] - p[2]) + p[3] - p[0]))),
    biValue: (p, tx, ty) => CubicInterpolator.value([
        CubicInterpolator.value(p[0], ty),
        CubicInterpolator.value(p[1], ty),
        CubicInterpolator.value(p[2], ty),
        CubicInterpolator.value(p[3], ty),
    ], tx),
    triValue: (p, tx, ty, tz) => CubicInterpolator.value([
        CubicInterpolator.biValue(p[0], ty, tz),
        CubicInterpolator.biValue(p[1], ty, tz),
        CubicInterpolator.biValue(p[2], ty, tz),
        CubicInterpolator.biValue(p[3], ty, tz),
    ], tx),
};
/**
 * Creates a tester function that returns true when a given number is within
 * the given tolerance of given number a
 * @param a The number to test against
 * @param tolerance the allowed tolerance
 * @returns the tester function with signature (v:number) => boolean
 */
export const equalsTester = (a, tolerance) => {
    return (b) => Math.abs(a - b) <= tolerance;
};
/**
 * Finds all common elements in a and b (aka the set intersection) and returns them.
 * @param a set of numbers a
 * @param b set of numbers b
 * @param tolerance the tolerance to be used when comparing the elements
 * @returns the intersection of set a and b
 */
export const setIntersection = (a, b, tolerance) => {
    const _b = b.map((v) => v); //copy b
    const c = a.reduce((c, va) => {
        const isEQ = equalsTester(va, tolerance);
        let ib = _b.findIndex(isEQ);
        if (ib != -1) {
            _b.splice(ib, 1);
            c.push(va);
        }
        return c;
    }, []);
    return c;
};
